import { apiRequest } from "@/services/api-client";
import { InventoryEnergyOutput, WebAppRoutes } from "types/web-app";

export const listEnergy = () =>
  apiRequest<InventoryEnergyOutput>("/" + WebAppRoutes.INVENTORY_ENERGY);
